/** REST client for the ad set / ad attribution endpoints. */
import { AdLevel } from "@/types/ad-hierarchy";
import type {
  AdHierarchySyncResult,
  AdLevelMetrics,
  AdRoutingNode,
} from "@/types/ad-hierarchy";

import { requestData } from "@/api/api-config";

export async function fetchCampaignAdSets(
  campaignId: string,
): Promise<AdLevelMetrics | null> {
  return requestData<AdLevelMetrics>(
    `opportunity/analytics/campaign/${campaignId}/ad-sets`,
    "get",
  );
}

export async function fetchAdSetAds(
  adSetId: string,
): Promise<AdLevelMetrics | null> {
  return requestData<AdLevelMetrics>(
    `opportunity/analytics/ad-set/${adSetId}/ads`,
    "get",
  );
}

export async function syncAdHierarchy(
  campaignId: string,
): Promise<AdHierarchySyncResult | null> {
  return requestData<AdHierarchySyncResult>(
    `opportunity/campaigns/${campaignId}/ad-hierarchy/sync`,
    "post",
    undefined,
    false,
  );
}

export async function fetchAdRouting(
  campaignId: string,
): Promise<AdRoutingNode[] | null> {
  return requestData<AdRoutingNode[]>(
    `opportunity/campaigns/${campaignId}/ad-routing`,
    "get",
  );
}

export async function setLevelRouting(
  level: AdLevel.AdSet | AdLevel.Ad,
  id: string,
  pipelineId: string | null,
): Promise<{ pipelineId: string | null } | null> {
  const resource = level === AdLevel.AdSet ? "ad-sets" : "ads";
  return requestData<{ pipelineId: string | null }>(
    `opportunity/${resource}/${id}/routing`,
    "patch",
    { json: { pipeline_id: pipelineId } },
    false,
  );
}
